<div class="auth-fullpage">
  <div id="logo-container" [@fadeInGlideUp]="authService.animationDuration">
    <app-logo width="217px" height="48px" class="svg-bold"></app-logo>
  </div>

  <div id="component-container" class="position-relative" [@fadeInGlideDown]="authService.animationDuration">
    <c-card id="component-view-port" class="w-30 p-3 position-absolute top-50 start-50 translate-middle-x">
      <c-card-body>
        <c-container fade>
          <form (submit)="onSubmit($event)">
            <c-alert
              color="success"
              class="d-flex align-items-center"
              [style.direction]="authService.language.direction"
            >
              <c-container class="confirmation-container">
                <c-row>
                  <c-col class="text-bold">{{ 'AUTH_LOGOUT_SUCCESS_CHANGE_PASSWORD_REQUEST' | translate }}</c-col>
                </c-row>
              </c-container>
              <i [ngClass]="`${iconsStyle} ${iconSize} ${icons.checkCircle}`"></i>
            </c-alert>
            <app-control-button-submit
              [parentComponent]="this"
              [buttonText]="'AUTH_LOGOUT_BUTTON_SIGN_IN_AGAIN'"
              [icon]="icons.actionRedo"
              [iconRotation]="180"
              id="loginBack"
            >
            </app-control-button-submit>
          </form>
        </c-container>
      </c-card-body>
    </c-card>
  </div>
</div>
